import { Box, Skeleton } from "@mui/material";

export const BarChartSkeleton = () => {
    return (
        <Box
            sx={{
                width: '100%',
                height: 300,
                px: 2,
                pt: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                justifyContent: 'flex-end',
            }}
        >
            {/* Y-Axis label placeholders */}
            <Box sx={{ display: 'flex', gap: 1 }}>
                <Box flexShrink={0} sx={{ width: 30, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    {Array.from({ length: 5 }).map((_, i) => (
                        <Skeleton key={i} variant="text" width={20} height={10} />
                    ))}
                </Box>

                {/* Bar placeholders */}
                <Box flex={1} display="flex" alignItems="end" gap={1}>
                    {Array.from({ length: 5 }).map((_, i) => (
                        <Skeleton key={i} variant="rectangular" width="100%" height={`${50 + (i % 3) * 30}px`} sx={{ flex: 1 }} />
                    ))}
                </Box>
            </Box>

            {/* X-Axis label placeholders */}
            <Box sx={{ display: 'flex', mt: 1, gap: 1, pl: 4 }}>
                {Array.from({ length: 6 }).map((_, i) => (
                    <Skeleton key={i} variant="text" width="100%" height={10} sx={{ flex: 1 }} />
                ))}
            </Box>
        </Box>
    );
};
